import request from '@/utils/request';

/**
 * 用户相关接口
 * @method login 登录
 * @method loginout 登出
 * @method getUsers 分页查询用户
 * @method addUser 添加用户
 * @method editUser 编辑用户
 * @method deleteUser 删除用户
 * @method changeUserStatus 修改用户状态（启用/禁用）
 * @method changePasswordForAdmin 管理员修改普通用户密码
 * @method changePassword 当前用户修改密码
 * @method changeExpireTime 修改用户有效期
 * 
 * @method getImgCode 获取图形验证码
 * 
 * @method getRoleAll 获取所有角色
 */
export function login (data) {
  return request({
    url: '/api/user/login',
    method: 'GET',
    params: data,
    requestToken: false,
  })
}

export function loginout () {
  return request({
    url: '/api/user/logout',
    method: 'GET',
  })
}

export function getUsers (data) {
  return request({
    url: '/api/user/users',
    method: 'GET',
    params: data,
  })
}

export function addUser (data) {
  return request({
    url: '/api/user/add',
    method: 'POST',
    data,
  })
}

export function editUser (data) {
  return request({
    url: '/api/user/modify',
    method: 'POST',
    data,
  })
}

export function deleteUser (data) {
  return request({
    url: '/api/user/delete',
    method: 'DELETE',
    params: data,
  })
}

export function changeUserStatus (data, action) {
  return request({
    url: `/api/user/${action}`,
    method: 'POST',
    data,
  })
}

export function changePasswordForAdmin (data) {
  return request({
    url: '/api/user/changePasswordForAdmin',
    method: 'POST',
    data,
  })
}

// `force` 是否强制修改密码，强制修改时必须传递 `token`
export function changePassword (data, force, token) {
  return request({
    url: '/api/user/changePassword',
    method: 'POST',
    data,
    headers: {
      'access-token': force ? token : null,
    }
  })
}

export function changeExpireTime (data) {
  return request({
    url: '/api/user/effect',
    method: 'POST',
    data,
  })
}

export function getCodeImg () {
  return request({
    url: '/api/user/image',
    method: 'GET',
    responseType: 'blob'
  })
}

// 角色
export function getRoleAll (data) {
  return request({
    url: '/api/role/all',
    method: 'GET',
  })
}






// WEBPACK FOOTER //
// ./src/api/user.js